<template>
    <content-string-edit v-if="content" :content="content" :back-route="{ name: 'system-content-strings' }" />
</template>
<script>
import contentService from '../../../services/content.service'

import ContentStringEdit from '../../common/content/string/content-string-edit.vue'

export default {
    name: 'system-content-strings-edit',
    components: { ContentStringEdit },
    data() {
        return {
            content: null
        }
    },
    computed: {
        contentId() {
            return this.$route.params.contentId;
        }
    },
    async created() {
        this.content = await contentService.getString(this.contentId);
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/strings/edit.vue